<article>
	<header>
		<h3>
			{{ 'adminstat.common.billing tail' | translate }}
		</h3>
	</header>
	
	<section>
		<cache-date></cache-date>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
		<hr/>
	</section>
	
	<section>
		<form>
			<div
				class="form-check"
				*ngFor="let radio of ['usersWithSite', 'usersWithOrNotSite']"
			>
				<label>
					<input
						type="radio"
						[(ngModel)]="filter.filterParams.userRegType"
						[ngModelOptions]="{standalone: true}"
						[value]="radio" [checked]="filter.filterParams.userRegType == radio"
						(change)="userRegTypeChange()"
					>
					
					{{ 'adminstat.filterForm.' + radio | translate }}
				</label>
			</div>
		</form>
	</section>
	
	<section>
		<chart [data]="withTailChart.data" [options]="withTailChart.options" [sextant]="'withTailChart'"></chart>
		<hr/>
		
		<chart [data]="withoutTailChart.data" [options]="withoutTailChart.options" [sextant]="'withoutTailChart'"></chart>
		<hr/>
		
		<chart [data]="onlyTailChart.data" [options]="onlyTailChart.options" [sextant]="'onlyTailChart'"></chart>
		
		<hr/>
	</section>
	
	<section>
		
		<table class="table table-striped table-bordered">
			<thead class="fixed_header">
			<tr class="table-primary">
				<th>{{ 'adminstat.common.Date' | translate }}</th>
				
				<th>
					{{ 'adminstat.filterForm.' + filter.filterParams.userRegType | translate }}
				</th>
				
				<th colspan="2">{{ 'adminstat.billing.billing_tail.paids' | translate }} {{params.user21billingStart}}-{{params.user21billingEnd}}</th>
				
				<th colspan="2">{{ 'adminstat.billing.billing_tail.paids' | translate }} > {{(params.user21billingEnd) + 1}}</th>
				
				<th>{{ 'adminstat.billing.billing_tail.conversion summary' | translate }}</th>
				
				<th>{{ 'adminstat.billing.billing_tail.conversion without a tail' | translate }}</th>
			</tr>
			</thead>
			
			<tbody class="js-container">
			<tr *ngIf="listLoader"><td colspan="8"><loading [isLoad]="listLoader"></loading></td></tr>
			
			<tr *ngFor="let row of rows;">
				<ng-container *ngIf="!row.middleCaption">
					<td style="text-align: right;">
						{{ row.label }}
					</td>
					
					<td>
						{{ row.usersWithSite }}
					</td>
					
					<td>
						{{ row.headCount }}
					</td>
					
					<td>
						{{ row.headPercent }} %
					</td>
					
					<td>
						{{ row.tailCount }}
					</td>
					
					<td>
						{{ row.headPercent > 0 ? roundBy(100 - row.headPercent, 2) : 0}} %
					</td>
					
					<td title="100 * ({{row.headCount}} + {{row.tailCount}}) / {{row.usersWithSite}}">
						{{ roundBy(100 * ((row.headCount + row.tailCount) / row.usersWithSite), 2) }} %
					</td>
					
					<td title="100 * {{row.headCount}} / {{row.usersWithSite}}">
						{{ roundBy(100 * (row.headCount / row.usersWithSite), 2) }} %
					</td>
				</ng-container>
				<ng-container *ngIf="row.middleCaption">
					<td colspan="8"><strong>{{ 'adminstat.billing.billing_tail.average annual' | translate }}</strong></td>
				</ng-container>
			</tr>
			</tbody>
		</table>
	</section>
</article>
